import React, { FC } from 'react'
import { Wrapper, Download, A } from './style'

type Props = {
  project: 'fepo' | 'training'
  specId: number
  specName: string | undefined
  specLoading: boolean
}

export const Sort: FC<Props> = ({ project, specLoading, specId, specName }) => {
  return (
    <Wrapper $project={project}>
      <label style={{ margin: '10px 10px 10px 0' }}>Дисциплины</label>
      {!specLoading && !!specId &&
        <>
          <Download>
            <a
              className="btn btn-primary"
              href={`/fgos_pim_struct/getXlsx?specId=${specId}&project=${project}&name=${specName}`}
            >
              Скачать список дисциплин
            </a>
          </Download>
        </>
      }
    </Wrapper>
  )
}
